import { render, staticRenderFns } from "./Chat-form.vue?vue&type=template&id=2fbb68d0&"
import script from "./Chat-form.vue?vue&type=script&lang=js&"
export * from "./Chat-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports